// export const API_PATH = "http://43.202.168.206/"
// export const API_PATH = "http://43.202.168.206:8008/"
// export const API_PATH = process.env.REACT_APP_API_URL
// const environment = process.env.REACT_APP_ENV;

//get api path from env file or use default
// export const API_PATH = process.env.REACT_APP_API_URL || "http://localhost:8008/"
// export const WS_PATH = process.env.REACT_APP_WS_URL || "ws://localhost:9001/"
export const API_PATH = process.env.REACT_APP_API_URL || "https://apis.cradle-vision.com/"
export const WS_PATH = process.env.REACT_APP_WS_URL || "wss://webs.cradle-vision.com/"
export const CAM_PATH = process.env.REACT_APP_CAM_URL || "https://cam.cradle-vision.com/"

export const MODEL_PATH = process.env.REACT_APP_MODEL_URL || "https://model.cradle-vision.com/"



// export const API_PATH = "https://api.cradle-vision.com/"
// export const WS_PATH = "wss://socket.cradle-vision.com/"

// export const API_PATH = "http://172.22.3.13:8008/"
// export const WS_PATH = "ws://172.22.3.13:9001/"

// export const API_PATH = "http://172.22.3.13:8008/"
// export const WS_PATH = "ws://172.22.3.13:9001/"



export const CONFIG = {headers: {"Authorization": "Bearer " + localStorage.getItem('token')}}
